import styles from './index.module.sass'
import BunkerSvg from './index.svg'

export const BunkerBadge = ({ label }: { label: string }) => {
    return (
        <div className={styles.root}>
            <span> { label } </span>
            <img src={BunkerSvg} alt="bunker"/>
        </div>
    )
}